module.exports = __webpack_public_path__ + "static/header_avatar-10d3450d3ac578facccbd58dd884d5dc.png";